import React from 'react';
import { Controller } from 'react-hook-form';

import { FormFieldValues } from 'containers/CommunityFormPage/CommunityForm/formType';
import { NonprofitsSelector } from 'retired/FormNonprofitsSelector/NonprofitsSelector';

export const NonprofitsController = (): JSX.Element => (
  <Controller<FormFieldValues, 'nonprofits'>
    name="nonprofits"
    render={({ field }): JSX.Element => (
      <NonprofitsSelector
        value={field.value}
        onChange={(newValue): void => field.onChange(newValue)}
      />
    )}
  />
);
